export default {
  init() {
      jQuery(document).on('click', '.zd-cart-plus, .zd-cart-minus', e => {
        this.updateQuantity(e.target)
      })
  },
  updateQuantity(target) {
    const $input = jQuery(target).siblings('.quantity:first').find('input.qty')
    if (!$input.length) return

    const val = parseInt($input.val())
    const step = parseInt($input.attr('step') || 1)
    const amount = jQuery(target).is('.zd-cart-plus') ? (val + step) : (val - step)

    if (val > 0) $input.val(amount)

    setTimeout(() => {
      jQuery('[name="update_cart"]').removeAttr('disabled').trigger('click');
    }, 0)
  },
};
